import { Component, OnInit, HostListener } from '@angular/core';
import { VenueService } from '../services/venue.service';
import { ActivatedRoute } from '@angular/router';
import { TabItem } from '../tabs/tabs.component';
import { AgreementService } from '../services/agreement.service';

@Component({
  selector: 'app-venue-details',
  templateUrl: './venue-details.component.html',
  styleUrls: ['./venue-details.component.css']
})
export class VenueDetailsComponent implements OnInit {

  venue: Venue | null = null;
  venueEditData: Venue | null = null;
  loadingVenue: boolean = false;
  loadingAgreements: boolean = false;
  disableModalSaveButton: boolean = false;
  isSavingModal: boolean = false;

  agreements: Agreement[] = [];

  // modal visibility
  editBasicVenueDetailsIsActive: boolean = false;
  editVenueDetailsIsActive: boolean = false;
  editVenueAddressIsActive: boolean = false;
  editVenueSocialIsActive: boolean = false;
  editVenueSettingsIsActive: boolean = false;

  // modal extras
  modalErrorMessage: string = ""

  // upload image
  imageUploadError: string = "";
  imageUploading: boolean = false;

  // Tabs functionality
  activeTab: string = 'details';
  tabs: TabItem[] = [
    { id: 'details', label: 'Details', icon: 'info' },
    { id: 'address', label: 'Address', icon: 'location_on' },
    { id: 'social', label: 'Social Media', icon: 'share' },
    { id: 'settings', label: 'Settings', icon: 'settings' }
  ];

  quillConfiguration = {
		toolbar: [
		  ['bold', 'italic', 'underline'],
		  ['blockquote'],
		  [{ list: 'ordered' }, { list: 'bullet' }],
		  [{ header: [1, 2, 3, 4, 5, 6, false] }],
		  ['link'],
		  ['clean'],
		],
	};

  constructor(private venueService: VenueService, private route: ActivatedRoute, private agreementService: AgreementService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const venue_id = params.get('venue_id');
      if (venue_id) {
        this.loadVenueDetails(parseInt(venue_id));
      }
    });
  }

  loadVenueDetails(venue_id: number): void {
    this.venueService.getVenueDetails('kt_venue_id', venue_id).subscribe(
      (data) => {
        this.venue = data;
        // this.getAgreements();
      },
      (error) => {
        console.error("Error fetching venue details:", error);
      }
    );
  }

  updateBasicVenueData(){
    const payload = {
      "venue_name": this.venueEditData?.name
    }
    this.updateVenue(payload);
  }

  updateVenueDetails(){
    const payload = {
      "venue_description": this.venueEditData?.venue_description ?? "",
      "site_url": this.venueEditData?.site_url,
      "venue_phone": this.venueEditData?.phone,
      "venue_email": this.venueEditData?.email
    }
    this.updateVenue(payload);
  }

  updateVenueAddress(){
    const payload = {
      "venue_address": this.venueEditData?.address,
      "venue_city": this.venueEditData?.city,
      "venue_state": this.venueEditData?.state,
      "venue_zip": this.venueEditData?.zip_code
    }
    this.updateVenue(payload);
  }

  updateVenueSocial(){
    const payload = {
      "venue_facebook": this.venueEditData?.facebook,
      "venue_twitter": this.venueEditData?.twitter,
      "venue_instagram": this.venueEditData?.instagram
    }
    this.updateVenue(payload);
  }

  updateVenueSettings(){
    const payload = {
      "zone": this.venueEditData?.zone,
      "private_client": this.venueEditData?.private_client,
      "test_venue": this.venueEditData?.test_venue,
      "capacity": this.venueEditData?.capacity,
      "tables": this.venueEditData?.tables
    }
    this.updateVenue(payload);
  }

  updateVenue(payload: any): void {
    if (!this.venue || !this.venueEditData) return;
    this.modalErrorMessage = "";
    this.isSavingModal = true;
    this.disableModalSaveButton = true;

    this.venueService.updateVenue(this.venue.kt_venue_id, payload).subscribe({
      next: (updatedVenue) => {
        this.venue = { ...this.venue, ...updatedVenue } as Venue;
        this.isSavingModal = false;
        this.disableModalSaveButton = false;
        this.editBasicVenueDetailsIsActive = false;
        this.editVenueDetailsIsActive = false;
        this.editVenueAddressIsActive = false;
        this.editVenueSocialIsActive = false;
        this.editVenueSettingsIsActive = false;
      },
      error: (error) => {
        console.error("Error updating venue details:", error);
        this.modalErrorMessage = error.error.detail ? error.error.detail : "An error occurred while updating venue details.";
        this.isSavingModal = false;
        this.disableModalSaveButton = false;
      }
    });
  }


  openBasicVenueDetailsModal() {
    this.editBasicVenueDetailsIsActive = true;
    this.venueEditData = { ...this.venue } as Venue;
  }

  showEditModal(modalType: 'details' | 'address' | 'social' | 'settings') {
    this.editVenueDetailsIsActive = modalType === 'details';
    this.editVenueAddressIsActive = modalType === 'address';
    this.editVenueSocialIsActive = modalType === 'social';
    this.editVenueSettingsIsActive = modalType === 'settings';
    this.venueEditData = { ...this.venue } as Venue;
  }



  // tabs
  onTabChange(tabId: string) {
    this.activeTab = tabId;
  }

  uploadVenueImage() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';

    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.handleImageUpload(file);
      }
    };

    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  }

  private handleImageUpload(file: File) {
    this.imageUploadError = "";
    this.imageUploading = true;
    if (!this.venue) return;

    if (!file.type.startsWith('image/')) {
      this.imageUploadError = 'Please select a valid image file.';
      this.imageUploading = false;
      return;
    }

    const maxSize = 15 * 1024 * 1024; // 15MB
    if (file.size > maxSize) {
      this.imageUploadError = 'File size must be less than 15MB.';
      this.imageUploading = false;
      return;
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('venue_id', this.venue.kt_venue_id.toString());

    this.venueService.uploadVenueImage(this.venue.kt_venue_id, formData).subscribe({
      next: (response: any) => {
        this.imageUploading = false;
        if (this.venue && typeof response === 'object') {
          this.venue.venue_image = response.url;
        }else{
          this.imageUploadError = 'Failed to upload image. Please try again.';
        }
      },
      error: (error) => {
        this.imageUploading = false;
        console.error('Error uploading image:', error);
        this.imageUploadError = 'Failed to upload image. Please try again.';
      }
    });
  }




}
